import PreformatifDiagnostic, {
  PreformatifDiagnosticAnswers,
  PreformatifDiagnosticHeader,
} from "@/interfaces/PreformatifDiagnostic";
import api from "@/services/api";

export const preformatifDiagnosticApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPreformatifDiagnostic: build.query<PreformatifDiagnostic | null, [string, string]>({
      query: ([companyId, courseId]) => `/companies/${companyId}/courses/${courseId}/preformatif-diagnostic`,
      providesTags: (_r, _e, [companyId, courseId]) => [{ type: "PreformatifDiagnostics", id: `${companyId}:${courseId}` }],
    }),
    getPreformatifDiagnosticHeader: build.query<PreformatifDiagnosticHeader, [string, string]>({
      query: ([companyId, courseId]) => `/companies/${companyId}/courses/${courseId}/preformatif-diagnostic/header`,
    }),
    savePreformatifDiagnostic: build.mutation<PreformatifDiagnostic, [string, string, PreformatifDiagnosticAnswers]>({
      query: ([companyId, courseId, answers]) => ({ url: `/companies/${companyId}/courses/${courseId}/preformatif-diagnostic`, method: "POST", body: { answers } }),
      invalidatesTags: (_r, _e, [companyId, courseId]) => [{ type: "PreformatifDiagnostics", id: `${companyId}:${courseId}` }],
    }),
    updatePreformatifDiagnostic: build.mutation<PreformatifDiagnostic, [string, string, PreformatifDiagnosticAnswers]>({
      query: ([companyId, courseId, answers]) => ({ url: `/companies/${companyId}/courses/${courseId}/preformatif-diagnostic`, method: "PATCH", body: { answers } }),
      invalidatesTags: (_r, _e, [companyId, courseId]) => [{ type: "PreformatifDiagnostics", id: `${companyId}:${courseId}` }],
    }),
    finalizePreformatifDiagnostic: build.mutation<PreformatifDiagnostic, [string, string, PreformatifDiagnosticAnswers]>({
      query: ([companyId, courseId, answers]) => ({ url: `/companies/${companyId}/courses/${courseId}/preformatif-diagnostic/finalize`, method: "POST", body: { answers } }),
      invalidatesTags: (_r, _e, [companyId, courseId]) => [{ type: "PreformatifDiagnostics", id: `${companyId}:${courseId}` }],
    }),
    exportPreformatifDiagnosticPdf: build.query<{ link?: string }, [string, string]>({
      query: ([companyId, courseId]) => `/companies/${companyId}/courses/${courseId}/preformatif-diagnostic/pdf`,
    }),
  }),
  overrideExisting: true,
});

export const { useGetPreformatifDiagnosticQuery, useGetPreformatifDiagnosticHeaderQuery, useLazyExportPreformatifDiagnosticPdfQuery, useSavePreformatifDiagnosticMutation, useUpdatePreformatifDiagnosticMutation, useFinalizePreformatifDiagnosticMutation } = preformatifDiagnosticApi;
